import axios from '@/util/axios'
import { NEW_API_CONFIG, DEV_API_TOKEN } from '@/util/constants'
import store from '@/store'
import { handleApiError as handleError } from '@/util/axios_common'

/**
 * 検索条件追加API
 * @param  {} params={}
 */
export const add = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/SC/001', r).catch(handleError)
}

/**
 * 検索条件一覧API
 * @param  {} params={}
 */
export const list = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/SC/002', r).catch(handleError)
}

/**
 * 検索条件一覧件数取得API
 * @param  {} params={}
 */
export const count = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/SC/003', r).catch(handleError)
}

/**
 * 検索条件更新API
 * @param  {} params={}
 */
export const update = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id

  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/SC/004', r).catch(handleError)
}

/**
 * 検索条件削除API
 * @param  {} params={}
 */
export const remove = (params = {}) => {
  const token = store.state.auth.token
  const organizationId = store.state.profile.organization_id
  
  const r = {
    ...params,
    token: token,
    organization_id: organizationId
  }

  const newAxios = axios.create(NEW_API_CONFIG)
  return newAxios.post('/SC/005', r).catch(handleError)
}
